var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLatencyIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4a8 8 0 00-8 8h1a6 6 0 0110.446-4.029L8.735 10.14a2 2 0 101.126 1.126l2.106-2.633A5.972 5.972 0 0113 12h3a8 8 0 00-8-8z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLatencyIcon);
export default __webpack_public_path__ + "static/media/latency-icon.a74e64dacc41dd305f66373854311216.svg";
export { ForwardRef as ReactComponent };